import { render, staticRenderFns } from "./TitleWithDescription.vue?vue&type=template&id=3060ed5c&"
import script from "./TitleWithDescription.vue?vue&type=script&lang=ts&"
export * from "./TitleWithDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports